import { createContext } from 'react'

interface ProductCarouselContextType {
  activeItem: string | null;
  portalId: string;
  setActiveItem: (id: string | null) => void;
}
export const ProductCarouselContext = createContext<ProductCarouselContextType>({
  activeItem: null,
  portalId: '',
  setActiveItem: () => {}
})
